"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionButton = exports.ActionContainer = exports.ContentContainer = exports.Card = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const button_1 = __importDefault(require("@kyruus/button"));
const ui_theme_1 = require("@kyruus/ui-theme");
const TRANSITION_TIMING_EASE_OUT_QUINT = `
  transition-timing-function: cubic-bezier(0.22, 1, 0.36, 1);
`;
const VisuallyHiddenStyles = `
  border: 0;
  clip: rect(0 0 0 0);
  height: auto;
  margin: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
`;
exports.Card = (0, styled_1.default)('div') `
  position: relative;
  border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  border-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
  height: 100%;
  width: 100%;
`;
exports.ContentContainer = (0, styled_1.default)('div') `
  z-index: 2;
  width: 100%;
`;
exports.ActionContainer = (0, styled_1.default)('div') `
  position: absolute;
  top: ${({ offsetY }) => `calc(0px - ${offsetY / 2}px)`};
  left: ${({ offsetX }) => `calc(100% - ${offsetX}px)`};
  z-index: 1;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  padding: 0 ${(0, ui_theme_1.fromTheme)('spacing_xsmall')};
  ${({ offsetX, offsetY }) => !offsetX || !offsetY ? VisuallyHiddenStyles : ''};
  & > button {
    outline: transparent;
    transform-origin: bottom center;
    transition: 0.25s;
    ${TRANSITION_TIMING_EASE_OUT_QUINT};
    @media (prefers-reduced-motion: reduce) {
      transition: none !important;
    }
    &,
    &:hover,
    &:focus,
    &:active {
      background-color: transparent;
      border: none;
    }
    &:hover:not(:disabled),
    &:focus {
      transform: scale(1.2);
    }
    &:focus {
      outline: 2px solid;
    }
    &:active:active {
      transform: scale(1);
    }
  }
`;
exports.ActionButton = (0, styled_1.default)(button_1.default) `
  padding: 0;
`;
//# sourceMappingURL=ActionCard.styles.js.map